import React from 'react';
import './cart-product-box.scss';
import { FiMinusCircle, FiPlusCircle } from 'react-icons/fi';
import { IoMdCloseCircleOutline } from 'react-icons/io';
import { saveCart, getCart, clearLocalStorage } from '../util/localStorage';
import { Link } from 'react-router-dom';
import { storage } from '../../app-firebase/firebase';
import ReactLoading from 'react-loading';
import noImageAvailable from '../../images/products/no_image_book.jpg';


class CartProductBox extends React.Component {

   constructor(props) {
      super(props);
      this.state = {
         image: ''
      }
   }

   componentDidMount() {
      if (!this.props.prod.product.stock) {
         if (this.props.prod.product.image) {
            storage.ref().child(this.props.prod.product.image[0]).getDownloadURL().then(url => {
               if (this.state.image !== url) {
                  this.setState({
                     image: url
                  });
               }
            });
         }
      } else {
         if (!this.state.image) {
            this.setState({
               image: noImageAvailable
            });
         }
      }
   }

   componentDidUpdate() {
      if (this.props.prod.product.image) {
         storage.ref().child(this.props.prod.product.image[0]).getDownloadURL().then(url => {
            if (this.state.image !== url) {
               this.setState({
                  image: url
               });
            }
         });
      }
      if (!this.props.prod.product.stock) {
         if (this.props.prod.product.image) {
            storage.ref().child(this.props.prod.product.image[0]).getDownloadURL().then(url => {
               if (this.state.image !== url) {
                  this.setState({
                     image: ''
                  });
               }
            });
         }
      } else {
         if (!this.state.image) {
            this.setState({
               image: noImageAvailable
            });
         }
      }
   }

   addToCart() {
      const cart = getCart();
      clearLocalStorage();
      cart.push(this.props.prod.product);
      cart.forEach(prod => {
         saveCart(prod);
      })
      this.props.updateProductsList();
      this.props.updateCartStorage();
   }

   removeOneFromCart() {
      const cart = getCart();
      clearLocalStorage();
      let foundFirst = false;
      let moreThanOne = false;
      for (let i = 0; i < cart.length; i++) {
         if (this.props.prod.product.ipNumber === cart[i].ipNumber) {
            if (foundFirst) moreThanOne++;
            if (!foundFirst) {
               foundFirst = !foundFirst;
               continue;
            }
         }
         saveCart(cart[i]);
      }
      if (moreThanOne) {
         this.props.updateCartStorage();
         this.props.updateProductsList();
      }
      else {
         this.setState({ image: '' }, () => {
            this.props.updateCartStorage();
            this.props.updateProductsList();
         });
      }
   }


   removeAllFromCart() {
      const cart = getCart();
      clearLocalStorage();
      for (let i = 0; i < cart.length; i++) {
         if (cart[i].ipNumber !== this.props.prod.product.ipNumber) {
            saveCart(cart[i])
         }
      }
      this.setState({ image: '' }, () => {
         this.props.updateCartStorage();
         this.props.updateProductsList();
      });
   }

   
   render() {
      const price = this.props.currency === 'CAD' ? this.props.prod.product.priceCad : this.props.prod.product.priceUsd;

      const prodLink = '/products/' + this.props.prod.product.ipNumber;

      return (
         <div className="cart-product-box d-flex align-items-center">
            {
               this.state.image ?
                  <img alt={this.props.prod.product.title} src={this.state.image} id="cl-legend-1" className="cl-legend-1" style={{width: '3rem', marginRight: '1rem'}}></img> :
                  <div className=" d-flex justify-content-center align-items-center" style={{width:'7rem',height: '10rem'}}>
                     <ReactLoading type={"spokes"} color={"black"} style={{width:'3rem'}}/>
                  </div>
            }
            <div className="cl-legend-2" id="cl-legend-2">
               <Link to={prodLink}><p>{this.props.prod.product.title}</p></Link>
               {this.props.prod.product.subtitle ? <Link to={prodLink}><p style={{fontSize: '.8rem'}}>{this.props.prod.product.subtitle.substring(0, 40) + '...'}</p></Link> : null}
            </div>
            <div className="cl-legend-3" id="cl-legend-3">
               <p className="p-mb-0">{this.props.currency}</p>
               <p className="p-mb-0">{price ? `${price.toFixed(2)}` : null}</p>
            </div>
            
            <div className="cpb-qty d-flex flex-column cl-legend-4" id="cl-legend-4">
               <div className="plus-minus-button" style={{marginBottom: '.5rem'}} onClick={() => this.addToCart()}><p className="plus-minus-button-p"><FiPlusCircle/></p></div>
               <input type="input" className="cart-qty" disabled value={this.props.prod.qty}></input>
               <div className="plus-minus-button" style={{marginTop: '.5rem'}} onClick={() => this.removeOneFromCart()}><p className="plus-minus-button-p"><FiMinusCircle/></p></div>
            </div>
            <div className="cl-legend-5" id="cl-legend-5">
               <p className="p-mb-0">{this.props.currency}</p>
               <p className="p-mb-0">{`${(price * this.props.prod.qty).toFixed(2)}`}</p>
            </div>
            
            <div className="plus-minus-button remove-button" onClick={() => this.removeAllFromCart()}><IoMdCloseCircleOutline /></div>
         </div>
      )
   }
}



export default CartProductBox;